import './bottom-sheet-transition-without-close.sass'

export default {

    install(Vue, options) {
    }

}
